import { Grid, Paper, Typography } from '@mui/material'
import { OogSubForm } from '@planning/components/organisms/OogSubForm/OogSubForm'
import { DangerousGoodsSubForm } from '@planning/pages/Order/V2/organisms/DangerousGoodsSubForm'
import { DirectionalCargoDetailsType } from '@planning/pages/Order/V2/organisms/DirectionalCargoDetailsSubForm'
import { StowageInstructionsSubForm } from '@planning/pages/Order/V2/organisms/StowageInstructionsSubForm'
import { CargoDetailsSubFormStore } from '@planning/pages/Order/V2/stores/CargoDetailsSubFormStore'
import { StowageInstructionAutocompleteViewStore } from '@planning/stores/stowageInstruction/StowageInstructionAutocompleteViewStore'
import { useTranslate } from '@tolgee/react'
import { IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

interface OrderSpecialHandlingCardProps {
  cargoDetailsFormStore: CargoDetailsSubFormStore
  directionalCargoDetailsFormStore: IFormStore<DirectionalCargoDetailsType>
  initialValues?: Partial<DirectionalCargoDetailsType>
  autoCompleteStore: StowageInstructionAutocompleteViewStore
  hideStowageInstruction?: boolean
  disableUnloadingMethod?: boolean
}

export const OrderSpecialHandlingCard = observer(
  ({
    cargoDetailsFormStore,
    directionalCargoDetailsFormStore,
    initialValues,
    autoCompleteStore,
    hideStowageInstruction = false,
    disableUnloadingMethod,
  }: OrderSpecialHandlingCardProps) => {
    const { t } = useTranslate()

    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Grid container spacing={2} direction={'column'}>
          <Grid>
            <Typography variant='subtitle1'>{t('specialHandling', 'Special handling')}</Typography>
          </Grid>
          <Grid>
            <Grid container spacing={2} direction={'column'}>
              <DangerousGoodsSubForm store={cargoDetailsFormStore.dangerousGoods} />
              {!cargoDetailsFormStore.isEmpty.value && (
                <OogSubForm
                  formStore={directionalCargoDetailsFormStore}
                  name='oog'
                  initialValue={initialValues?.oog}
                  disableUnloadingMethod={disableUnloadingMethod}
                />
              )}
              {!hideStowageInstruction && (
                <StowageInstructionsSubForm
                  store={directionalCargoDetailsFormStore}
                  initialValues={initialValues?.stowageInstruction}
                  autoCompleteStore={autoCompleteStore}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    )
  },
)
